"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ModelVisibilitiesService", {
    enumerable: true,
    get: function() {
        return ModelVisibilitiesService;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _apphooksservice = require("~/services/app-hooks/app-hooks.service");
const _helpers = require("~/helpers");
const _catchError = require("~/helpers/catchError");
const _models = require("~/models");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let ModelVisibilitiesService = class ModelVisibilitiesService {
    async xcVisibilityMetaSetAll(context, param) {
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/VisibilityRuleReq', param.visibilityRule);
        const base = await _models.Base.getWithInfo(context, param.baseId);
        if (!base) {
            _catchError.NcError.baseNotFound(param.baseId);
        }
        for (const d of param.visibilityRule){
            for (const role of Object.keys(d.disabled)){
                const view = await _models.View.get(context, d.id);
                if (view.base_id !== param.baseId) {
                    _catchError.NcError.badRequest('View does not belong to the base');
                }
                const dataInDb = await _models.ModelRoleVisibility.get(context, {
                    role,
                    fk_view_id: d.id
                });
                if (dataInDb) {
                    if (d.disabled[role]) {
                        if (!dataInDb.disabled) {
                            await _models.ModelRoleVisibility.update(context, d.id, role, {
                                disabled: d.disabled[role]
                            });
                        }
                    } else {
                        await dataInDb.delete(context);
                    }
                } else if (d.disabled[role]) {
                    await _models.ModelRoleVisibility.insert(context, {
                        fk_view_id: d.id,
                        disabled: d.disabled[role],
                        role
                    });
                }
                if (!!d.disabled[role] !== !!(dataInDb == null ? void 0 : dataInDb.disabled)) {
                    this.appHooksService.emit(_nocodbsdk.AppEvents.UI_ACL, {
                        base,
                        req: param.req,
                        context,
                        view,
                        role,
                        disabled: !!d.disabled[role]
                    });
                }
            }
        }
        return true;
    }
    async xcVisibilityMetaGet(context, param) {
        const { includeM2M = true, baseId, models: _models1 } = param != null ? param : {};
        // todo: move to
        const roles = [
            'owner',
            'creator',
            'viewer',
            'editor',
            'commenter',
            'guest'
        ];
        const defaultDisabled = roles.reduce((o, r)=>_extends({}, o, {
                [r]: false
            }), {});
        let models = _models1 || await _models.Model.list(context, {
            base_id: baseId,
            source_id: undefined
        });
        models = includeM2M ? models : models.filter((t)=>!t.mm);
        const result = await models.reduce(async (_obj, model)=>{
            const obj = await _obj;
            const views = await model.getViews(context);
            for (const view of views){
                obj[view.id] = _extends({
                    ptn: model.table_name,
                    _ptn: model.title,
                    ptype: model.type,
                    tn: view.title,
                    _tn: view.title,
                    table_meta: model.meta
                }, view, {
                    disabled: _extends({}, defaultDisabled)
                });
            }
            return obj;
        }, Promise.resolve({}));
        const disabledList = await _models.ModelRoleVisibility.list(context, baseId);
        for (const d of disabledList){
            if (result[d.fk_view_id]) result[d.fk_view_id].disabled[d.role] = !!d.disabled;
        }
        return Object.values(result);
    }
    constructor(appHooksService){
        this.appHooksService = appHooksService;
    }
};
ModelVisibilitiesService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _apphooksservice.AppHooksService === "undefined" ? Object : _apphooksservice.AppHooksService
    ])
], ModelVisibilitiesService);
